import { Flex, Icon, Image, Text } from '@chakra-ui/react'
import React, { useEffect, useRef } from 'react'

import AudioPreviewer from './AudioPreviewer.jsx'

const ProctoringPreview = ({
    icon,
    title,
    stream,
    mirror = false,
    marginTop = 2,
    marginBottom = 4,
}) => {
    const playerRef = useRef(null)
    useEffect(() => {
        if (stream && stream.active) {
            playerRef.current.srcObject = stream
        }
    }, [stream])

    return (
        <Flex flexDirection={'column'}>
            <Flex alignItems="center">
                <Icon as={icon} fontSize="2xl" className="dark:text-gray-300" />
                <Text
                    ml={2}
                    fontSize="xs"
                    color="dovegray"
                    className="dark:text-gray-300"
                >
                    {title}
                </Text>
            </Flex>
            <Flex
                height={112}
                width={200}
                bgColor="black"
                justifyContent="center"
                alignItems="center"
                mt={marginTop}
                mb={marginBottom}
                position={'relative'}
            >
                {stream && stream.active ? (
                    <>
                        <video
                            autoPlay
                            muted
                            playsInline
                            width={'100%'}
                            style={{
                                transform: mirror ? 'scaleX(-1)' : 'none',
                                maxHeight: 112,
                            }}
                            ref={playerRef}
                        />
                        {stream?.getAudioTracks()?.length > 0 && (
                            <Flex top={0} right={0} position={'absolute'} m={2}>
                                <AudioPreviewer audioStream={stream} />
                            </Flex>
                        )}
                    </>
                ) : (
                    <Image src="/images/webcam_blur.gif" />
                )}
            </Flex>
        </Flex>
    )
}

export default ProctoringPreview
